import React from "react";
import { PagingInfo, Sorting } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";
const options = [
  // {
  //   name: "Related",
  //   value: "created_time",
  //   direction: ""
  // },
  {
    name: "New arrival order",
    value: "created_time",
    direction: "desc",
  },
  {
    name: "Relevance order",
    value: "created_time",
    direction: "",
  },
];

const SortingByCategory = () => {
  const { t } = useTranslation();

  return (
    <Sorting
      sortOptions={options}
      view={({ className, label, onChange, options, value, ...rest }) => {
        const selectedValue = value;

        const selectedOption =
          selectedValue && selectedValue !== "|||"
            ? options.find((option) => option.value === selectedValue)
            : options[1];

        return (
          <select
            name={label}
            className="sui-select u-mt0"
            value={selectedOption.value}
            onChange={(e) => onChange(e.target.value)}
          >
            {options.map((option, index) => {
              return (
                <option value={option.value} key={index}>
                  {t(option.label)}
                </option>
              );
            })}
          </select>
        );
      }}
    />
  );
};

const OmronPagingInfo = () => {
  const { t } = useTranslation();
  return (
    <div className="u-flex u-flex--middle u-flex--end u-mb10">
      <PagingInfo
        view={({ totalResults }) => (
          <p className="u-font--s u-font--bold u-mb0">
            {t("pagingInfo", { totalResults: totalResults })}
          </p>
        )}
      />

      <div className="u-form-select">
        <SortingByCategory />
      </div>
    </div>
  );
};

export default OmronPagingInfo;
